import type { RouteObject } from 'react-router-dom';
import { paths } from '@/router/paths';
import { CustomerListPage } from './CustomerListPage';
import { CustomerCreatePage } from './CustomerCreatePage';
import { CustomerDetailPage } from './CustomerDetailPage';

export const customerRoutes: RouteObject[] = [
  { path: paths.customers, element: <CustomerListPage /> },
  { path: paths.customerCreate, element: <CustomerCreatePage /> },
  { path: paths.customerDetail, element: <CustomerDetailPage /> }
];
